import React,{useState, useEffect} from 'react';
import MenuPreview from './menuPreview';
import RodapePreview from './rodapePreview';
import {DivDescricaoSobreMim} from './stylePreviewSobreMim';
import {URLIMG} from '../../helpers/constantes'
export default function PreviewSobreMim(){
    let logo = JSON.parse(localStorage.getItem('currentUser'));


    return(<div style={{overflow:'auto',background:'#fff',height:'100vh'}}>
        <MenuPreview />
        <div style={{display:'flex',flexDirection:'column'}}>
            <div style={{display:'inherit',width:'100%', justifyContent:'center'}}>
                <img src={URLIMG+logo.Cover} alt='' style={{maxWidth:'100%'}}/>
            </div>
            <div style={{margin:'0 150px'}}>
                <h1 style={{margin:'50px 60px'}}>Sobre Mim</h1>
            </div>
            <div style={{display:'inherit', flexDirection:'row',margin:'0 150px'}}>
                <div style={{margin:'0 60px'}}>
                    <img style={{height:'350px'}}src={URLIMG+logo.Picture}></img>
                </div>
                <div>
                    <DivDescricaoSobreMim style={{whiteSpace:'break-spaces'}}>
                       {logo.Description}
                    </DivDescricaoSobreMim>
                </div>
            </div>
        </div>
        <RodapePreview/>
    </div>)
}
